import { render, staticRenderFns } from "./ExchangeWarningLayout.vue?vue&type=template&id=59757536&"
import script from "./ExchangeWarningLayout.vue?vue&type=script&lang=js&"
export * from "./ExchangeWarningLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports